import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { LockKeyhole, LogIn } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Brand } from './Brand';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/auth`;
const options = { withCredentials: true };

export const AdminAccess = ({ children }) => {
  const [user, setUser] = useState(undefined);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    document.title = 'Acesso administrativo | FATT Elevadores';
    const robots = document.createElement('meta');
    robots.name = 'robots'; robots.content = 'noindex, nofollow'; document.head.appendChild(robots);
    let active = true;
    axios.get(`${API}/me`, options).catch(async failure => {
      if (failure.response?.status !== 401) throw failure;
      return axios.post(`${API}/refresh`, {}, options);
    }).then(response => { if (active) setUser(response.data); }).catch(() => { if (active) setUser(null); });
    return () => { active = false; robots.remove(); };
  }, []);
  const login = async event => {
    event.preventDefault(); if (busy) return;
    setBusy(true); setError('');
    try {
      const response = await axios.post(`${API}/login`, { email: email.trim(), password }, options);
      setPassword(''); setUser(response.data);
    } catch (failure) {
      const detail = failure.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Não foi possível entrar. Confira os dados e tente novamente.');
    } finally { setBusy(false); }
  };
  const logout = async () => {
    await axios.post(`${API}/logout`, {}, options);
    setUser(null); setPassword(''); setError('');
  };
  if (user === undefined) return <div className="min-h-screen flex items-center justify-center" role="status" data-testid="admin-session-check">Verificando acesso…</div>;
  if (user) return children({ logout, sessionExpired: () => setUser(null) });
  return <main className="min-h-screen bg-gray-50 flex items-center justify-center p-6" data-testid="admin-login-page">
    <section className="w-full max-w-sm bg-white border border-gray-200 p-7">
      <a href="/" aria-label="Voltar ao site da FATT Elevadores" data-testid="admin-login-home"><Brand testId="admin-login-logo" /></a>
      <h1 className="text-2xl font-semibold mt-7 mb-2 flex items-center gap-2" data-testid="admin-login-title"><LockKeyhole size={22} /> Acesso administrativo</h1>
      <form onSubmit={login} className="space-y-5 mt-6" data-testid="admin-login-form">
        <div><label htmlFor="admin-email" className="text-sm block mb-2" data-testid="admin-email-label">E-mail</label><Input id="admin-email" type="email" autoComplete="username" required value={email} onChange={event => setEmail(event.target.value)} disabled={busy} data-testid="admin-email" /></div>
        <div><label htmlFor="admin-password" className="text-sm block mb-2" data-testid="admin-password-label">Senha</label><Input id="admin-password" type="password" autoComplete="current-password" required maxLength={72} value={password} onChange={event => setPassword(event.target.value)} disabled={busy} data-testid="admin-password" /></div>
        {error && <p role="alert" className="text-sm text-red-700" data-testid="admin-login-error">{error}</p>}
        <Button type="submit" className="fatt-button button-red w-full" disabled={busy} data-testid="admin-login-submit"><LogIn size={18} />{busy ? 'Entrando…' : 'Entrar'}</Button>
      </form>
    </section>
  </main>;
};